var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroneLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 152,
    viewBox: "0 0 45 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.4206 1C8.12931 9.46645 -8.40422 30.0415 7.7919 44.6102C28.037 62.8211 52.3325 56.1118 41.1977 77.6773C30.0629 99.2428 7.7919 86.3035 7.7919 113.141C7.7919 134.61 14.8777 147.326 18.4206 151",
    stroke: "#131313",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneLine);
export default __webpack_public_path__ + "static/media/drone-line.7b5fe2d843ea19fdcdda415fa5484711.svg";
export { ForwardRef as ReactComponent };